import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["recipients", "customProperties"],
  _excluded2 = ["recipients", "customProperties"];
import { createImmutableObjectClass } from 'immutable-less/ImmutableObject';
import { List as ImmutableList, Map as ImmutableMap } from 'immutable';
import * as ActionTypes from 'automation-ui-action-features/constants/ActionTypes';
import AssociationSpec from 'automation-ui-associations/records/AssociationSpec';
import ActionInput from 'automation-ui-action-features/action-inputs/records/ActionInput';
export default class EmailActionMetadata extends createImmutableObjectClass({
  actionType: ActionTypes.EMAIL,
  contentId: null,
  emailCampaignId: null,
  emailCampaignGroupId: null,
  appId: null,
  utmSource: null,
  recipients: [],
  customProperties: {}
}, {
  fromJSON: _ref => {
    let {
        recipients,
        customProperties
      } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);
    return Object.assign({
      recipients: ImmutableList((recipients || []).map(recipient => {
        var _recipient$associatio;
        return ImmutableMap({
          associationSpec: new AssociationSpec((_recipient$associatio = recipient === null || recipient === void 0 ? void 0 : recipient.associationSpec) !== null && _recipient$associatio !== void 0 ? _recipient$associatio : {})
        });
      })),
      customProperties: customProperties && Object.entries(customProperties !== null && customProperties !== void 0 ? customProperties : {}).map(([name, value]) => new ActionInput({
        name,
        value
      }))
    }, rest);
  },
  toJSON: _ref2 => {
    let {
        recipients,
        customProperties
      } = _ref2,
      rest = _objectWithoutPropertiesLoose(_ref2, _excluded2);
    return Object.assign({
      recipients: recipients.toJS(),
      customProperties: customProperties && Object.fromEntries(customProperties.map(({
        name,
        value
      }) => [name, value]))
    }, rest);
  }
}) {
  getEmailId() {
    return this.contentId;
  }
  getRecipients() {
    return this.recipients;
  }
  setRecipients(recipients) {
    return this.set('recipients', recipients);
  }
  setRecipientAssociation(association) {
    const associationSpec = association ? ImmutableList([ImmutableMap({
      associationSpec: new AssociationSpec({
        associationCategory: association.category,
        associationTypeId: association.id
      })
    })]) : [];
    return this.set('recipients', ImmutableList(associationSpec));
  }
  isNew() {
    return !this.getEmailId();
  }
}